import React, { useCallback } from "react";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import s from "./index.module.scss";
import Slide from "./Slide";
import {
  DotButton,
  useDotButton,
} from "@/components/Homepage/Hero/useDotButton";
import {
  NextButton,
  PrevButton,
  usePrevNextButtons,
} from "@/components/Homepage/Hero/usePrevNextButtons";

const isDev = process.env.NODE_ENV !== "production";

const HomepageHero = ({ slice, hero, page = "" }) => {
  const options = {};
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [
    Autoplay({ delay: isDev ? 40000 : 4500 }),
  ]);

  const onNavButtonClick = useCallback((emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const resetOrStop =
      autoplay.options.stopOnInteraction === false
        ? autoplay.reset
        : autoplay.stop;

    resetOrStop();
  }, []);

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(
    emblaApi,
    onNavButtonClick,
  );

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi, onNavButtonClick);

  return (
    <section className="home-hero">
      <div className={s.embla} ref={emblaRef}>
        <div className={s.embla__container}>
          {hero?.map((data, idx) => {
            return (
              <div className={s.embla__slide} key={idx}>
                <Slide data={data} index={idx} />
              </div>
            );
          })}
        </div>

        <div className="embla__controls">
          <div className="embla__buttons">
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
            />
            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
            />
          </div>
        </div>
      </div>
      <div className="embla__dots">
        {scrollSnaps.map((_, index) => (
          <DotButton
            key={index}
            onClick={() => onDotButtonClick(index)}
            className={"embla__dot".concat(
              index === selectedIndex ? " embla__dot--selected" : "",
            )}
          />
        ))}
      </div>
    </section>
  );
};

export default HomepageHero;
